<div class="smart-tags-location-for-pin" *ngIf="smartTagLocationFlow.step === smartTagLocationStep.PIN">
    <div class="smart-tag-pin-mode">
        <div>
            <label>Place the pin and Confirm</label>
        </div>

        <button [disabled]="smartTagLocation === null"
                (click)="createSnapshot()"
                type="button"
                class="btn btn-primary">
            <i class="fas fa-map-pin"></i> Confirm Placement
        </button>

        <div class="btn-cancel">
            <label (click)="setPinSelectorMode(false)">Cancel</label>
        </div>
    </div>
</div>

<div class="smart-tags-location-for-pin" *ngIf="smartTagLocationFlow.step === smartTagLocationStep.EMPTY">
    <div class="smart-tags-list-empty">
        <div>
            <label>No Smart Tags Created</label>
        </div>
        <button *ngIf="isEditable"
            class="btn btn-primary"
            type="button" 
            (click)="setPinSelectorMode(true)" >
            <i class="fas fa-solid fa-tag"></i> Create Smart Tag
        </button>
    </div>
</div>

<div class="smart-tag-location-for-list" *ngIf="smartTagLocationFlow.step === smartTagLocationStep.LIST">
    <cv-schema-render-smart-tags
            [data]="data"
            [layoutNode]="layoutNode"
            (create)="setPinSelectorMode(true)"
            (edit)="onEdit($event)"
    ></cv-schema-render-smart-tags>
</div>

<div class="smart-tag-location-for-form"
     *ngIf="smartTagLocationFlow.step === smartTagLocationStep.CREATE || smartTagLocationFlow.step === smartTagLocationStep.EDIT">
    <div class="cv-schema-render-resource-media-control">
        <div class="report-media-control-form-container">
            <div class="info-container">
                <div class="info-wrapper">
                    <div class="info-parameters">
                        <div>
                            <cv-schema-render-smart-tag-form
                                    [data]="data"
                                    [resourceModel]="smartTagLocationFlow.resourceModel"
                                    [filterBy]="smartTagLocationFlow.filterBy">
                            </cv-schema-render-smart-tag-form>
                        </div>
                        <div class="action-buttons flex-container">
                            <div>
                                <button class="btn btn-sm cv-btn-light discard" (click)="onCancel()">
                                    <span>Discard</span>
                                </button>
                            </div>
                            <div class="btn-save-wrapper">
                                <button class="btn btn-sm cv-btn-light" (click)="onSave()"
                                        [disabled]="isSavingInProcess || !isFormValid()">
                                    <span>Save</span>
                                    <div *ngIf="isSavingInProcess" class="loading-wrapper">
                                        <i class="fas fa-spinner"></i>
                                    </div>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
